import React, { useCallback, useMemo } from "react";
import * as Scrivito from "scrivito";
import { LinkButtonWithChevron } from "components/LinkButtonWithChevron";
import cx from "classnames";
import { useAppBaseContext, useConfiguratorPopupContext } from "providers";
import { LeftSidebarSubNavHeader } from "components/LeftSidebar/LeftSidebarSubNavHeader";
import { useGetSubnavItemTitle } from "hooks";
import { useFetchProject, useInitOpenMap } from "hooks/projectHooks";

import s from "components/LeftSidebar/LeftSidebar.module.scss";

const singleObjClass = [
  "ProjectConfigurator",
  "ProjectItem",
  "ProjectItemSame",
];
const scrollToTop = () => {
  const divToScroll = document.querySelector("#application");
  if (divToScroll) {
    divToScroll.scrollTo({
      top: divToScroll.offsetTop,
      behavior: "smooth",
    });
  }
};
export const FirstSubnavItem = ({
  referenceObj,
  projectId,
  seriesId,
  setActiveButton,
}) => {
  const objClass = referenceObj.objClass();
  const linkTitle = useGetSubnavItemTitle(objClass);
  const { isProd } = useAppBaseContext();
  const isProdReady = referenceObj.get("isProdReady");
  const { isUpdateButtonActive, showConfiguratorPopup } =
    useConfiguratorPopupContext();
  const initOpenMap = useInitOpenMap();
  const fetchProjectData = useFetchProject({
    onSuccess: ({ data }) => {
      initOpenMap(data.project.projectNodes);
    },
  });

  const isDisabled = useMemo(
    () =>
      (!projectId && singleObjClass.some((item) => item === objClass)) ||
      (objClass === "ProductConfigurator" && !seriesId),
    [projectId, objClass, seriesId],
  );

  const urlParams = useMemo(() => {
    if (objClass === "ProjectList") {
      return projectId ? { projectId } : null;
    }
    if (objClass === "ProjectListSame") {
      return projectId ? { projectId } : null;
    }
    if (objClass === "ProductConfigurator") {
      return { projectId, seriesId };
    }
    return { projectId };
  }, [objClass, seriesId, projectId]);

  const handleClick = useCallback(() => {
    const isWizardPage = window.location.href.includes("wizard");
    if (isWizardPage) {
      fetchProjectData();
    }
    const navigate = () => {
      scrollToTop();
      setActiveButton(null);
      Scrivito.navigateTo(referenceObj, urlParams);
    };
    if (isUpdateButtonActive) {
      showConfiguratorPopup(navigate);
    } else {
      navigate();
    }
  }, [
    isUpdateButtonActive,
    fetchProjectData,
    setActiveButton,
    referenceObj,
    urlParams,
    showConfiguratorPopup,
  ]);

  if (isProdReady === false && isProd) {
    return null;
  }

  return (
    <LinkButtonWithChevron
      disabled={isDisabled}
      params={urlParams}
      className={cx(s.leftSidebarSubNavLink, {
        [s.leftSidebarSubNavLinkDisabled]: isDisabled,
      })}
      onClick={handleClick}
    >
      <LeftSidebarSubNavHeader referenceObj={referenceObj} title={linkTitle} />
    </LinkButtonWithChevron>
  );
};
